import type { iSupplierBill } from "@sdk/supplier-bills/supplier-bill-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { supplierBillsDefaultQueryConfig } from "./supplier-bills-default-query";

export const {
  slice: SupplierBillsSlice,
  reducers: SupplierBillsSliceReducer,
  actions: {
    setEntityQueryResults: setSupplierBillsQueryResults,
    setEntity: setSupplierBill,
    setEntities: setSupplierBills,
    patchEntity: patchSupplierBill,
    addNewEntity: addNewSupplierBill,
    setEntityFetchingStatus: setSupplierBillFetchingStatus,
    setEntitiesFetchingStatus: setSupplierBillsFetchingStatus,
    setEntityFailedStatus: setSupplierBillFailedStatus,
    setEntityQueryError: setSupplierBillsQueryError,
    resetQuery: resetSupplierBillsQuery,
    setQueryList: setSupplierBillQueryList,
  },
} = CreateEntitySlice<iSupplierBill>({
  sliceName: "supplierBills",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...supplierBillsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
